const userInterface = {
	showingUserPanel: false,
	logouting: false,
	palette: 'Purple',
	lang: 'English',
	mode: 'Light'
}
export default userInterface;